export class FeatureItem {
  feature: string;
  graphicAttr: string;
  attrId: string;
  items: any[];
  gotoCenter?: boolean = false;
  exportable?: boolean = false;
  graphicArray: boolean;
}

export const GRAPHIC_ATTRS = {
  CHACRA: 'geometry',
  CHACRA_FACTOR_LS_ASIGNADO: 'chacraFactorLSGeometriaAsignado',
  CHACRA_FACTOR_LS_LIMITANTE: 'chacraFactorLSGeometriaLimitante',
  ZONA_EXCLUSION: 'zonaExclusionGeometria',
  ADJUNTO: 'adjuntoGeoreferencia',
};


export const GRAPHIC_ATTR_IDS = {
  CHACRA: 'id',
  ZONA_EXCLUSION: 'zonaExclusionId',
  ADJUNTO: 'adjuntoId',
};
